<template>
    <div>
        <el-dialog
                title="Add User"
                :visible.sync="add_user_show">
            <el-input style="margin-bottom:10px" placeholder="User Name (like John Doe)" v-model="tentative_user_name"></el-input>
            <el-input style="margin-bottom:10px" placeholder="Email address" v-model="tentative_email"></el-input>
          <div style="margin-bottom:10px">Role:
            <el-select v-model="tentative_role">
              <el-option
                  v-for="role in roles"
                  :key="role.key"
                  :label="role.name"
                  :value="role.key">
              </el-option>
            </el-select>
          </div>
          <div v-if="tentative_org.max_clients>1">
            <div style="margin-bottom:10px;">
              <el-radio v-model="tentative_extents_radio" label="all">Assign to all clients</el-radio>
              <el-radio v-model="tentative_extents_radio" label="some">Assign to one or some clients</el-radio>
            </div>
            <div style="margin-bottom:10px;">
              <el-select filterable v-show="tentative_extents_radio==='some'" v-model="tentative_user_extents" multiple placeholder="Select">
                <el-option
                    v-for="extent in tentative_org.extents"
                    :key="extent.id"
                    :label="extent.name"
                    :value="extent.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="margin-bottom:10px">Default Extent ID:
            <el-input v-model="tentative_default_extent_id"></el-input>
          </div>
          <el-button style="margin-top:20px" v-on:click="AddUser">Add User</el-button>
        </el-dialog>
        <div class="row">
            <div class="col-md-12 ">
                <div class="panel panel-default">
                    <div class="panel-heading">Quotas & Users</div>

                    <div class="panel-body">

                        <el-row v-for="(org, index) in org_data">
                            <h2>{{org.name}}</h2>
                                <div v-if="org.plan">
                                    <span style="background-color:lightgray;padding:10px;display:inline;margin-right:20px;">{{org.plan}}</span>
                                  <span v-if="org.invoiced_or_recurring==='recurring'">
                                    <a :href="org.billing_url">See/manage billing</a>
                                  </span>
                                  <span v-else>
                                    Manually Invoiced
                                  </span>
                                </div>
                                <div v-else>
                                    <el-button v-on:click="buy(org.id)" type="primary">Buy a license for {{org.name}}</el-button>
                                    <span style="color:gray;margin-left:10px;">Currently using free trial</span>
                                </div>
                            <h3>Active URL Quota</h3>
                            <div v-if="org.remaining.discover_urls">
                                {{org.remaining.discover_urls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                available of
                                {{org.max_discover_urls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                URLs total for your plan. This quota is available to the active clients below (or to new clients as they are added).</div>
                            <div v-else>None of the available
                                {{org.max_discover_urls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} URLs have been used.
                                This quota is available to the clients below (or to new clients as they are added).</div>
                            <div v-if="org.max_clients==1">
                                <h3>Active Digital Presence</h3>
                                <p>You have a license that allows you to have a single digital presence, defined as
                                    the sites owned by a single organization.</p>
                            </div>
                            <div v-else>
                                <h3>Active Clients / Digital Presences</h3>
                            </div>
                            <ol>
                                <li v-for="extent in org.extents_active">
                                    <strong>{{extent.name}}</strong> ({{extent.id}})
                                </li>
                            </ol>
                            <div style="color:#aaa;">
                                <div v-if="org.remaining.clients==1">
                                    You can add one digital presence under your current license. Any user of this organization can add other clients against this organization's quota.
                                </div>
                                <div v-else-if="org.remaining.clients==0">
                                    You cannot add any more clients under your current license.
                                </div>
                                <div v-else>
                                    You can add more clients under your current license. Any user of this organization can add other clients against this organization's quota.
                                </div>
                            </div>

                            <p></p>
                            <h3>Users</h3>
                            <ol>
                                <li v-for="user in org.users">
                                    <strong>{{user.name}}</strong> ({{user.email}})
                                    <span
                                        v-for="role in user.roles"
                                        :style="
                                          'color:'+
                                          role.display_info.text_color+
                                          ';background-color:' +
                                          role.display_info.color +
                                          ';border: 1px solid black; padding:2px;display:inline-block;margin:2px;font-size:smaller;'
                                        ">
                                        {{role.display_info.name}}

                                    </span>
                                </li>
                            </ol>
                            <div style="color:#aaa;">
                                <div v-if="org.remaining.users>0">
                                    You can still add
                                    {{org.remaining.users}} user{{org.remaining.users>1 ? 's' : ''}} (of a total of
                                    {{org.max_users}} available in your current plan).
                                    Adding a user will also give them access to all the clients listed above.
                                    If you need to give them limited access, contact David Hobbs Consulting.
                                </div>
                                <div v-else>
                                    You have used up the available users in your current license.
                                </div>
                            </div>
                            <el-button  v-if="org.remaining.users>0" style='margin-top:10px;' v-on:click="AddUserShow(org.id)">Add User to {{org.name}}</el-button>
                            <div v-if="org.extents_archived && org.extents_archived.length>0">
                              <div style="margin-top:20px;">
                                  <div>
                                      <h3>Archived Clients / Digital Presences</h3>
                                  </div>
                                  <ol>
                                      <li v-for="extent in org.extents_archived">
                                          <strong>{{extent.name}}</strong> ({{extent.id}})
                                      </li>
                                  </ol>
                              </div>
                            </div>
                            <div style="margin-top:20px;color:#aaa;border-bottom: 1px solid;"></div>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        mounted() {
            this.GetOrgs()
        },
        data() {
            return {
                org_data: null,
                add_user_show: false,
                tentative_email: null,
                tentative_user_name: null,
                tentative_org_id: null,
                tentative_user_extents: [],
                tentative_extents_radio: 'all',
                tentative_role: null,
                tentative_default_extent_id: null,
                roles: null,
            }
        },
        computed: {
          tentative_org: function () {
            let selected_org = {}
            if (this.org_data) {
              this.org_data.forEach(org => {
                if (org.id === this.tentative_org_id) {
                  selected_org = org
                }
              })
            }
            return selected_org
          },
        },
        methods: {
            GetOrgs() {
                axios.get("/api/orgs")
                    .then(response => {
                        console.log(response.data)
                        this.org_data = response.data
                    })
                    .catch(error => {
                        console.log("Could not get org list")
                    })
            },
            GetRoles(org_id) {
                axios.get("/api/roles/" + org_id)
                    .then(response => {
                      this.roles = response.data
                    })
                    .catch(error => {
                      console.log("Could not get roles")
                    })
            },
            AddUserShow(org_id) {
                this.GetRoles(org_id)
                this.add_user_show = true
                this.tentative_org_id = org_id
                console.log('adding user to ' + org_id)
            },
            AddUser() {
                this.add_user_show = false
                let org_id = this.tentative_org_id
                console.log('adding user to ' + org_id)
                axios.post('api/add_user_to_org', {
                    name: this.tentative_user_name,
                    email: this.tentative_email,
                    org_id: org_id,
                    extent_ids: this.tentative_user_extents,
                    default_extent_id: this.tentative_default_extent_id,

                }).then(response => {
                    console.log(response.data)
                    this.tentative_user_name = null
                    this.tentative_email = null
                    this.tentative_ord_id = null
                    this.GetOrgs()
                }).catch(error => {
                    console.log('oops problem saving')
                    console.log(error.response)
                    // NEED TO POST ERROR
                })
            },
            buy(org_id) {
                window.location.href = '/pricing/' + org_id
            },
        }
    }
</script>